$(document).ready(function(){
  var startBlog = Date.now();

  $("[data-comment-reply]").bind("click",function(){
    var index = $("[data-comment-row]").index($(this).closest("[data-comment-row]"));
    $("[data-comment-form]").insertAfter($("[data-comment-row]").eq(index));
    $("[data-comment-cancel]").show();
    var commentId = $(this).attr("data-comment-reply");
    $("[data-comment-form]").find("input[name='replay_to']").val(commentId);
    
    setTimeout(function(){
      $('.formErrors__item').hide();
    }, 3000);
  });

  $("[data-comment-form]").submit(function(){
    var submitBlog = Date.now();
    var formInvalid = false;

    $('[data-comment-form] input,[data-comment-form] textarea').each(function() {
      if (typeof $(this).attr('required') !== "undefined" && $(this).val() === '') {
        console.log($(this).attr('name'));
        formInvalid = true;
      }
    });

    if(!formInvalid && (submitBlog-startBlog)/1000>6){
      return true;
    }else{
      return false;
    }

    setTimeout(function(){
      $('.formErrors__item').hide();
    }, 3000);
    
  });
});
